// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"588":"b0425d76","1455":"8ba37de3","2342":"b0425d76","2977":"b80101b5","4170":"b0425d76","4475":"8ba37de3","5709":"b0425d76","6211":"2a028ab3","8130":"48c8fd76","8225":"8ba37de3"}[chunkId] + ".chunk.css";
};